import { render } from "./manual.vue?vue&type=template&id=a47c3866&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"

import "./manual.vue?vue&type=style&index=0&id=a47c3866&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47c3866"]])

export default __exports__